import script from "./PurchaseRentCountry.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseRentCountry.vue?vue&type=script&setup=true&lang=js"

import "./PurchaseRentCountry.vue?vue&type=style&index=0&id=fca16b70&lang=scss"

const __exports__ = script;

export default __exports__